module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"autoconvert_text":"The auto-conversion rate will be applied ({src} = {dest})"},"ru":{"autoconvert_text":"Будет применен курс автоконвертации ({src} = {dest})"}}')
  delete Component.options._Ctor
}
